export default function TransformNodeIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6"
        y="6"
        width="8"
        height="8"
        rx="1.4"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M10 3.5V6M10 14V16.5M3.5 10H6M14 10H16.5"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
    </svg>
  );
}
